export const DADOS_EXAME = 'dadosExame';
export const GRAU_DESCONFORTO_APARELHO_POLISSONOGRAFIA = 'grauDesconfortoAparelhoPolissonografia';
export const ESPECIFICACAO_CAUSA_DESCONFORTO = 'especificacaoCausaDesconforto';
export const HORA_ADORMECER = 'horaAdormecer';
export const TEMPO_DEMORA_INICIAR_SONO = 'tempoDemoraIniciarSono';
export const QUANTIDADE_DESPERTOU_NOITE = 'quantidadeDespertouNoite';
export const TEMPO_DORMIU_NOITE = 'tempoDormiuNoite';
export const GRAU_COMPARACAO_SONO_HABITUAL = 'grauComparacaoSonoHabitual';